export default () => (
{
  navIsOpen: false,
  scrolled: false,
  scrollbarWidth: 0,
  screenWidth: 0,

  getScrollbarWidth() {
    // Create a temporary div element
    const scrollDiv = document.createElement('div');

    // Style the div to force a scrollbar
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';  // This forces the scrollbar
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';      // Position it off-screen
    document.body.appendChild(scrollDiv);

    // Calculate the scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Remove the temporary div
    document.body.removeChild(scrollDiv);

    // Save the scrollbar width
    this.scrollbarWidth = scrollbarWidth;
  },

  init() {
    this.getScrollbarWidth();
  },
});
